import {useState, useEffect} from 'react';
import {SanityLink} from '../../types';
import Link from '../elements/Link';

type Props = {
  slides: {
    text: string;
    color: string;
    link: SanityLink;
  }[];
};

const Navigation = ({handlePrev, handleNext}: any) => {
  return (
    <>
      <button
        aria-label="announcement banner left button"
        onClick={() => handlePrev()}
        className="absolute left-3 rotate-180"
      >
        <svg
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.764229 12.2258C0.59033 12.2258 0.418055 12.1514 0.297782 12.0073C0.0834337 11.75 0.118105 11.3673 0.375432 11.153L6.28807 6.22595L0.375432 1.2989C0.118105 1.08456 0.0834337 0.701907 0.297782 0.444228C0.512491 0.186901 0.894408 0.15169 1.15246 0.366579L7.62446 5.75961C7.76315 5.87482 7.84297 6.04565 7.84297 6.2255C7.84297 6.40554 7.76333 6.57619 7.62446 6.69139L1.15246 12.0844C1.03869 12.1796 0.900728 12.2256 0.76403 12.2256L0.764229 12.2258Z"
            fill="white"
          />
        </svg>
      </button>
      <button
        aria-label="announcement banner right button"
        onClick={() => handleNext()}
        className="absolute right-3"
      >
        <svg
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.764229 12.2258C0.59033 12.2258 0.418055 12.1514 0.297782 12.0073C0.0834337 11.75 0.118105 11.3673 0.375432 11.153L6.28807 6.22595L0.375432 1.2989C0.118105 1.08456 0.0834337 0.701907 0.297782 0.444228C0.512491 0.186901 0.894408 0.15169 1.15246 0.366579L7.62446 5.75961C7.76315 5.87482 7.84297 6.04565 7.84297 6.2255C7.84297 6.40554 7.76333 6.57619 7.62446 6.69139L1.15246 12.0844C1.03869 12.1796 0.900728 12.2256 0.76403 12.2256L0.764229 12.2258Z"
            fill="white"
          />
        </svg>
      </button>
    </>
  );
};

export default function AnnouncementBanner({slides}: Props) {
  const [activeSlide, setActiveSlide] = useState(0);

  function handleNext() {
    clearInterval(interval);
    if (activeSlide < slides?.length - 1) {
      return setActiveSlide(activeSlide + 1);
    }
    return setActiveSlide(0);
  }
  function handlePrev() {
    clearInterval(interval);
    if (activeSlide > 0) {
      return setActiveSlide(activeSlide - 1);
    }
    return setActiveSlide(slides?.length - 1);
  }

  let interval: any;

  //run handleNext every 5 seconds to change slide automatically and reset timer on user interaction
  useEffect(() => {
    interval = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(interval);
  }, [activeSlide]);

  // When navigating back through history, `activeSlide` is not reset and can have a mismatch with the number of slides returned.
  // The below code ensure no index our of bounds is possible.
  if (activeSlide > slides?.length - 1) {
    return <></>;
  }

  const {text, color, link} = slides[activeSlide];

  return (
    <div
      style={{backgroundColor: color}}
      className="transition-standard blockH10 relative z-20 flex flex-col items-center justify-center gap-x-4 py-2 px-gutter text-center text-white md:flex-row"
    >
      <span>{text}</span>
      {link && (
        <Link link={link} className="underline">
          {link?.title}
        </Link>
      )}
      {slides?.length > 1 && (
        <Navigation handlePrev={handlePrev} handleNext={handleNext} />
      )}
    </div>
  );
}
